/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Input, Modal, Space, Empty, Checkbox } from 'antd'
import { AvatarStatus } from 'components/elements/AvatarStatus'
import { BaseButton } from 'components/elements/BaseButton'
import LoeadMorePagination from 'components/elements/BaseInfinityScroll/LoeadMorePagination'
import { BlockLoader } from 'components/elements/Loader'
import { TActionPlanLeads } from 'features/automation'
import useFetchPage from 'hooks/useFetchPage'
import { queryClient } from 'lib/react-query'
import { FC, useEffect, useMemo, useState } from 'react'
import {
 TAlertControlType,
 TAlertStatus,
 TControlAlertModal,
 useControlAlertMutation,
 useWithdrawAlertMutation,
} from 'features/alert'
import { globalConfirm } from 'components/elements/global'
import { InfinityPagination } from 'components/elements/BaseInfinityScroll'

const ControlAlertModal: FC<{
 controlType?: TAlertControlType
 onCancel?: () => void
 ctrlAlert: TControlAlertModal
 refetch?: () => void
 from?: 'action-plan' | 'real-estate-news' | 'market-updates'
}> = ({
 onCancel,
 ctrlAlert: { id, show, type, name: alertName },
 refetch,
 controlType,
 from = 'action-plan',
}) => {
 const [Ids, setIds] = useState<any[]>([])
 const [apActionType, setApActionType] = useState<'stop' | null>(null)
 const [newsLetterActionType, setNewsLetterActionType] = useState<
  'pause' | 'delete' | null
 >(null)
 const [selectAll, setSelectAll] = useState(false)
 const [unselected, setUnSelected] = useState<number[]>([])

 const [searchKey, setSearchKey] = useState('')
 const {
  flatData,
  isLoading,
  hasMore,
  fetchMore,
  totalCount,
  isFetching,
  isFetchingNextPage,
  refetch: refetchList,
 } = useFetchPage<TActionPlanLeads>('get-alert-leads', {
  method: 'post',

  body: useMemo(
   () => ({
    search: searchKey,
    type: [type],
    id: [id],
   }),
   [id, searchKey, type],
  ),
  customApiKey: `get-alert-leads-${id}-${type}-${searchKey}`,
 })

 useEffect(() => {
  refetchList?.()
 }, [])

 const [controlAction, { isLoading: controlActionLoading }] =
  useControlAlertMutation()

 const [withdrawAlert, { isLoading: withdrawAlertLoading }] =
  useWithdrawAlertMutation()

 const HandleControlAlert = async (
  action: TAlertStatus,
  alert_id?: any,
  leadId?: any[],
 ) => {
  globalConfirm({
   content: `Are you sure you want to ${action} Listing Alert for the selected lead(s)?`,
   onOk: async () => {
    await controlAction({
     action,
     alert_id,
     type: controlType ?? 'new_listing_alert',
     lead_id: selectAll && hasMore ? [] : leadId,
     ...(selectAll && hasMore
      ? {
         select_all: selectAll,
         unselected,
         filter_info: JSON.stringify({ search: searchKey }),
         from: type,
        }
      : {}),
    }).unwrap()
    queryClient.invalidateQueries(`get-alert-leads-${id}-${type}-${searchKey}`)
    queryClient.invalidateQueries('get-alerts')
    setApActionType(null)
    onCancel?.()
    refetch?.()
   },
  })
 }

 const handleDeleteAlert = async (alert_id?: any, leadID?: any[]) => {
  globalConfirm({
   content:
    'Are you sure you want to Remove Listing Alert for the selected lead(s)?',
   onOk: async () => {
    await withdrawAlert({
     alert_id,
     lead_id: selectAll && hasMore ? [] : leadID ?? [],
     ...(selectAll && hasMore
      ? {
         select_all: selectAll,
         unselected,
         filter_info: JSON.stringify({ search: searchKey }),
         from: type,
        }
      : {}),
    }).unwrap()

    queryClient.invalidateQueries('get-alert-leads')
    queryClient.invalidateQueries('get-alerts')
    onCancel?.()
    refetch?.()
   },
  })
 }

 const title = {
  Active: 'Active',
  Pause: 'Paused',
 }

 useEffect(() => {
  if (selectAll && flatData && flatData?.length > 0) {
   const newunSelected = new Set(unselected)
   const result = flatData
    ?.filter((obj) => !newunSelected.has(obj.id))
    .map((i) => i?.id)

   setIds(result as any)
  }
 }, [flatData, selectAll, unselected])

 useEffect(() => {
  if (!hasMore && selectAll && Ids?.length !== flatData?.length) {
   setSelectAll(false)
  }
 }, [flatData])

 return (
  <Modal
   visible={show}
   onCancel={onCancel}
   className="viewportModal"
   // Actions in the Modal footer stay fixed while the list scrolls
   footer={
    Ids && Ids.length > 0 ? (
     <Space>
      <BaseButton
       //  buttonType="secondary"
       customClass="btn-secondary-custom"
       onClick={() => {
        setSelectAll(false)
        setIds([])
        setUnSelected([])
        setApActionType(null)
       }}
      >
       Clear
      </BaseButton>
      <BaseButton
       buttonType="primary"
       //  loading={apActionType === null && controlActionLoading}
       onClick={() =>
        HandleControlAlert?.(type === 'Active' ? 'Pause' : 'Active', id, Ids)
       }
      >
       {type === 'Active' ? 'Pause' : 'Resume'}
       {selectAll && hasMore
        ? ` (${(totalCount ?? 0) - (unselected?.length ?? 0)})`
        : ` (${Ids && Ids.length})`}
      </BaseButton>
      <BaseButton
       //  loading={withdrawAlertLoading}
       buttonType="danger"
       onClick={() => {
        handleDeleteAlert?.(id, Ids)
       }}
      >
       Remove
       {selectAll && hasMore
        ? `(${(totalCount ?? 0) - (unselected?.length ?? 0)})`
        : `(${Ids && Ids.length})`}
      </BaseButton>
     </Space>
    ) : null
   }
   title={
    <span className="text-capitalize">{`${alertName} - ${
     type === 'Pause' ? 'Paused' : type
    } Leads`}</span>
   }
  >
   <div style={{ marginBottom: '12px' }}>
    <Input
     value={searchKey}
     onChange={(e) => setSearchKey(e.target.value)}
     placeholder="Enter your search"
    />
   </div>

   {isLoading ? (
    <div
     style={{ height: '160px' }}
     className="d-flex align-items-center justify-content-center"
    >
     <BlockLoader />
    </div>
   ) : (flatData?.length ?? 0) === 0 && !isLoading && !isFetching ? (
    <div
     style={{ height: '160px' }}
     className="d-flex align-items-center justify-content-center"
    >
     <Empty description="Lead Empty" />
    </div>
   ) : (
    <div className="viewportModal-scroll">
     {(flatData?.length ?? 0) > 0 && (
      // Sticky inside the scroll area so its checkbox aligns with the list's
      <div
       className="d-flex justify-content-end viewportModal-sticky"
       style={{ fontWeight: '500', paddingBottom: '8px' }}
      >
       <span
        style={{ paddingRight: '6px', cursor: 'pointer' }}
        onClick={() => {
         setSelectAll(!selectAll)
         if (selectAll) {
          setIds([])
         }
         setUnSelected([])
        }}
       >
        Select All
       </span>
       <Checkbox
        onChange={() => {
         setSelectAll(!selectAll)
         if (selectAll) {
          setIds([])
         }
         setUnSelected([])
        }}
        checked={selectAll}
       />
      </div>
     )}
     <InfinityPagination
      useWindow={false}
      hasMore={hasMore}
      loadMore={fetchMore}
     >
      {flatData &&
       flatData.length > 0 &&
       flatData.map((item, index) => (
        <AvatarStatus
         key={index}
         title={item.name}
         className="action-active-leads "
         action={
          <Checkbox
           onChange={() => {
            if (selectAll && hasMore) {
             setUnSelected((prv) => {
              if (prv.includes(item.id)) {
               return prv.filter((x) => x !== item.id)
              }
              return [...prv, item.id]
             })
            } else {
             setIds((prv) => {
              const find = prv.find((m) => m === item.id)
              if (find) {
               const filter = prv.filter((x) => x !== item.id)
               return [...filter]
              }
              return [...prv, item.id]
             })
            }

            //  if (Ids.find((x) => x === item.id)) {
            //   if (selectAll) {
            //    setSelectAll(false)
            //   }
            //  } else if (Ids.length + 1 === flatData?.length && !hasMore) {
            //   setSelectAll(true)
            //  }
           }}
           checked={
            selectAll && hasMore
             ? !unselected.includes(item.id)
             : !!Ids.find((x) => x === item.id)
           }
          />
         }
        />
       ))}
      {/* </div> */}
     </InfinityPagination>
    </div>
   )}
  </Modal>
 )
}

export default ControlAlertModal
